export default __webpack_public_path__ + "static/media/barbers-button-left.362cab2b.svg";